// extracted by mini-css-extract-plugin
export var actionButton = "_8a-1";
export var actionButtons = "_8a-2";
export var actions = "_8a-0";
export var aiUnread = "_8a-10";
export var alignCenter = "_8a-h";
export var backWrapper = "_8a-3";
export var cellContainer = "_8a-4";
export var checkboxContainer = "_8a-5";
export var contentContainer = "_8a-6";
export var contentHeader = "_8a-8";
export var conversationsTableWrapper = "_8a-s";
export var draftReplyBadgeContainer = "_8a-m";
export var dropdownItem = "_8a-b";
export var dropdownItemsContainer = "_8a-a";
export var dropdownTitle = "_8a-c";
export var errorIcon = "_8a-7";
export var filter = "_8a-d";
export var gray = "_8a-i";
export var headerActionButtons = "_8a-e";
export var headerCheckboxContainer = "_8a-f";
export var icon = "_8a-j";
export var menuContainer = "_8a-k";
export var noMoreTicketsIcon = "_8a-12";
export var noMoreTicketsSubText = "_8a-13";
export var oneLine = "_8a-l";
export var optionsButton = "_8a-n";
export var plus = "_8a-o";
export var portalButtonsWrapper = "_8a-g";
export var red = "_8a-p";
export var scrolledTop = "_8a-9";
export var search = "_8a-q";
export var selectedConversationsCount = "_8a-r";
export var spinner = "_8a-t";
export var strong = "_8a-u";
export var summaryCell = "_8a-v";
export var tableContainer = "_8a-11";
export var tagContainer = "_8a-w";
export var threeDots = "_8a-x";
export var twoLines = "_8a-y";
export var unread = "_8a-z";